export default {
  description:
    'Upload de dokumenter, vi skal bruge for at verificere din virksomhed. Påkrævede dokumenter er markeret; du kan tilføje de valgfrie nu eller senere.',
  missing_one:
    'Et påkrævet dokument mangler stadig. Du kan fortsætte: dette trin forbliver åbent, indtil det er uploadet.',
  missing_other:
    '{{count}} påkrævede dokumenter mangler stadig. Du kan fortsætte: dette trin forbliver åbent, indtil de er uploadet.',
  buttons: {
    back: 'Tilbage',
    next: 'Næste',
    finish_later: 'Afslut senere',
  },
};
